import type { TaskDataType } from "types/DataTypes";
import {
  getDateFromISOStringDatePart,
  getTimeFromISOString,
} from "utils/date-utils.ts";
import TaskTypePill from "components/TaskTypePill/TaskTypePill";

type CMSResponseItemType = {
  task: TaskDataType;
};

const CMSResponseTaskItem = ({ task }: CMSResponseItemType) => {
  const isQueryResponse = !!task.query_response_file_log_id;
  const dateRetrieved = isQueryResponse
    ? task.query_response_file_log__date_retrieved
    : task.claim_response_file_log__date_retrieved;

  return (
    <>
      <div className="data-block-header">
        RRE {task.rre_id} - {isQueryResponse ? "Query" : "Claim"} Response
      </div>

      <div className="data-values">
        <>
          <label>RRE Name:</label>
          <figure>{task.rre_name}</figure>

          <label>Date Received:</label>
          <figure>{getTimeFromISOString(dateRetrieved)}</figure>
        </>
        <label>Created at:</label>
        <figure>{getTimeFromISOString(task.created)}</figure>
      </div>

      <div className="tags">
        <TaskTypePill taskType={task.type} />

        {task?.products?.map((p, index) => (
          <span key={index}>{p.type}</span>
        ))}

        {/* show due date if it exists */}
        {task.due_date && (
          <div className="status">
            <span className="yellow">
              DUE {getDateFromISOStringDatePart(task.due_date)}
            </span>
          </div>
        )}
      </div>
    </>
  );
};

export default CMSResponseTaskItem;
